<template>
<form @submit.prevent="doSearch" method="post">
    <div class="nav-search">
        <input type="text" placeholder="请输入关键字" v-model="keyword" :class="[isActive ? 'activeSearch' : '']" @blur="handleBlur"/>
        <div class="btn-search" @click="open"></div>
      </div>
      </form>
</template>
<script>
export default {
  data(){
    return{
      keyword:null,
      isActive: false
    }
    
  },
  watch: {
    $route: {
      handler () {
        this.isActive = false
      }
    }
  },
  methods:{
  open(){
    this.isActive= !this.isActive
  },
  doSearch(){
    
      this.keyword = this.keyword.trim();
      this.$router.push({path: '/search/',query: { keyword:this.keyword}}).catch(()=>{});
      this.keyword = null
      this.activeClass = false
    },
    handleBlur(){
      this.keyword = null
      this.activeClass = false
    }
  },
}
</script>

<style scoped lang="less">
form{
  display:flex;
}
.nav-search {
      position: relative;
      line-height:60px;
      display: flex;
      align-items: center;
      font-size: 0;
      margin-top: -5px;
      input {
        width: 0;
        height: 33px;
        border-radius: 16px;
        padding-left: 40px;
        border: none;
        box-sizing: border-box;
        outline: none;
        display: block;
        transition: width 0.5s ease-in-out;
        &.activeSearch{
          width: 308px;
          background: #eef0f6;
        }
      }
      input:focus {
        background: #ffffff;
        border: 1px solid #4ea2c9 !important;
      }
      .btn-search {
        background:url("@/assets/images/header/search.png") no-repeat center;
        background-size:18px 19px;
        position: absolute;
        top: 50%;
        left: 4px;
        width: 32px;
        height: 32px;
        margin-top:-15px;
      }
    }
  @media (max-width: 768px) {
    form{
      display: block;
    }
    .nav-search {
      width:inherit;
      line-height:.495rem;
      input {
        width: 100%;
        height: .495rem;
        border-radius: .2475rem;
        padding-left: 0.64rem;  
      }
 
      .btn-search {
        background-image:url("@/assets/images/header/search-m.png");
        background-size:.29rem .3rem;
        width: .495rem;
        height: .495rem;
        margin-top:-.255rem;
      }
    }

  }
</style>